export default __webpack_public_path__ + "static/media/twitter.408f34be.svg";